import FormSearchCompany from './FormSearchCompany.container';

export default FormSearchCompany;
